import {LobbyController} from "../lobby/index";

const store = {
    actions: {
        socket_cacheGenerationFromTree(_, event) {
            if (is_current_user_presenter()) {
                VRMessageController.addMessage({text: event.data});
            }
        },

        socket_requestLobby(_, event) {
            if(is_current_user_presenter()){
                let text = event.user.username+ " is in the lobby";
                VRMessageController.addMessage({text: text});
            }
            LobbyController.addUserToLobby(event.user._id,  event.user.username);
            const time = wv.effectController.meetingInfo.data.settings.lobbyFeatures.reminderInterval* 1000;
            if (time !== 0) {
                LobbyController.callLobbyReminder(time);
            }
        },

        socket_removeUserFromLobbyMenu(_, event) {
            LobbyController.removeUserFromLobby(event.user);
        }
    }
};

export default function register(rootStore) {
    rootStore.registerModule('notificationManager', store);
}
